<template>
  <div>
    <Title>Not Found</Title>
    <SubTitle class="font-weight-bold">
      Sorry but we couldn't find this page.
    </SubTitle>
    <p>
      Try another URL or click elsewhere... Maybe
      <router-link :to="{ name: 'home' }"> home</router-link>?
    </p>
    <Guitarist />
  </div>
</template>
<script>
import Guitarist from "@/components/Guitarist.vue";

export default {
  name: "NotFoundPage",
  components: { Guitarist }
};
</script>
